// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.yc-select-search {
  display: flex;
  align-items: center;
  padding: 0 5px 0 16px;
  width: 100%;
  height: 37px;
  border-bottom: 1px solid var(--g-color-line-generic);
  box-sizing: border-box;
}
.yc-select-search__input-wrap {
  flex: 1 1 auto;
}`, "",{"version":3,"sources":["webpack://./src/ui/components/common/YCSelect/Search/Search.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,oDAAA;EACA,sBAAA;AACJ;AACI;EACI,cAAA;AACR","sourcesContent":[".yc-select-search {\n  display: flex;\n  align-items: center;\n  padding: 0 5px 0 16px;\n  width: 100%;\n  height: 37px;\n  border-bottom: 1px solid var(--g-color-line-generic);\n  box-sizing: border-box;\n}\n.yc-select-search__input-wrap {\n  flex: 1 1 auto;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
